import {
  PLACAS_LISTAR,
  PLACAS_LISTAR_SUCCESS,
  PLACAS_LISTAR_ERROR,
  GUARDAR_PLACA,
  GUARDAR_PLACA_SUCCESS,
  GUARDAR_PLACA_ERROR,
  ACTUALIZAR_PLACA,
  ACTUALIZAR_PLACA_SUCCESS,
  ACTUALIZAR_PLACA_ERROR,
} from './PlacasActions';

const initialState = {
  isActivityIndicatorShown: false,
  placas: [],
  paginacion: {
    limite: 10,
    actual: 1,
    filtro: '',
    orden: 'fh_creacion',
    sentido: 'ASC',
    total: 0,
  },
  isActivityIndicatorShown: false,
  error: null,
};

const placaReducer = (state = initialState, action) => {
  switch (action.type) {
    case PLACAS_LISTAR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };

    case PLACAS_LISTAR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        placas: action.respuestaServidor.placas,
        paginacion: action.respuestaServidor.paginacion,
      };
    case GUARDAR_PLACA:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };

    case GUARDAR_PLACA_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        placas: [...state.placas, action.respuestaServidor], // Añade la nueva placa a la lista
        error: null,
      };
    case ACTUALIZAR_PLACA_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        placas: state.placas.map((placa) =>
          placa.id === action.respuestaServidor.id
            ? action.respuestaServidor
            : placa
        ), // Actualiza la placa en la lista
        error: null,
      };
    case PLACAS_LISTAR_ERROR:
    case GUARDAR_PLACA_ERROR:
    case ACTUALIZAR_PLACA_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };
    default:
      return state;
  }
};

export default placaReducer;
